/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#fff" d="M14.735.827a1.411 1.411 0 010 1.996L9.742 7.816l4.99 4.99a1.406 1.406 0 01-1.988 1.99l-4.99-4.991-4.992 4.99A1.411 1.411 0 01.767 12.8l4.99-4.991-4.99-4.99A1.406 1.406 0 012.756.829l4.99 4.991L12.74.827a1.411 1.411 0 011.996 0z"/>'
  }
})
